import { render, staticRenderFns } from "./GrupaSingle.vue?vue&type=template&id=60ae4cac&scoped=true&"
import script from "./GrupaSingle.vue?vue&type=script&lang=js&"
export * from "./GrupaSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae4cac",
  null
  
)

export default component.exports